/* eslint-disable max-lines */
import {
  Container,
  Col,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  Button,
  Modal,
  FormGroup,
  Input,
  Label,
} from 'reactstrap';
import { useContext, useState, useEffect, useRef } from 'react';
import { toast } from 'react-toastify';
import { Context as AuthContext } from '../../../../contexts/AuthContext';
import CommonHeader from '../../../../components/Headers/CommonHeader';
import EmployeeService from '../../../../services/Employee';
import { FilteredOptionsInterface } from '../../../../entities/FilteredOptions';
import { PagedMetaInterface, createPagedMeta } from '../../../../entities/PagedMeta';
import { createOptionsPage } from '../../../../entities/OptionsPaged';
import DataTable from '../../../../components/Core/DataTable';
import FullCalendar, { EventContentArg } from '@fullcalendar/react';
import interactionPlugin from '@fullcalendar/interaction';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import ReactTooltip from 'react-tooltip';
import moment, { Moment } from 'moment';
import CardInfo from '../../../../components/Cards/CardInfo';
import ModalContent from '../../../../components/Modals/Modal';
import PtoService from '../../../../services/Pto';
import PtoRequestDetail from '../PtoRequestDetail';
import PtoReproveConfirm from '../PtoReproveConfirm';
import { confirmAlert } from 'react-confirm-alert';
import BlackoutDatesForm from '../BlackoutDatesForm';
import BlackoutDate from '../../../../services/BlackoutDate';
import isAdmin from '../../../../helpers/isAdmin';
import isDirector from '../../../../helpers/isDirector';
import UserBalanceDetailForm from '../UserBalanceDetailForm';
import Holidays from '../../../../services/Holidays';
import PtoHollidayDetail from '../PtoHollidayDetail';
import BalanceCollumns from './datatableCollumns/BalanceCollumns';
import RequestCollumns from './datatableCollumns/RequestCollumns';
import ScheduledCollumns from './datatableCollumns/ScheduledCollumns';
import { DatesSetArg } from '@fullcalendar/react';
import PenddingRequestInfo from './PenddingRequestInfo';
import useCheckMobileScreen from '../../../../hooks/useCheckMobileScreen';
import CardWidget from '../../../../components/Cards/CardWidget';
import isUpperManagement from '../../../../helpers/isUpperManagement';
import confirmAlertWithForm from '../../../../helpers/confirmAlertWithForm';
import ModalTimeoffRequest from './ModalTimeoffRequest';
import isHRUser from '../../../../helpers/isHRUser';
import isFinanceUser from '../../../../helpers/isFinanceUser';
import isEducationDirectorAdminAssistant from '../../../../helpers/isEducationDirectorAdminAssistant';
import FilterBar, { ActiveFilter, EnumOption, FilterFieldDef } from '../DirectoryList/DirectoryFilters';
import useDebounce from '../../../../hooks/useDebounce';
import useLatestRequest from '../../../../hooks/useLatestRequest';
import { isRequestCanceled } from '../../../../helpers/http';

const BALANCE_FILTER_FIELDS: FilterFieldDef[] = [
  { key: 'status', label: 'Status', type: 'enum', icon: 'fa-circle', backendField: 'status' },
  { key: 'policy', label: 'Policy Name', type: 'enum', icon: 'fa-file', backendField: 'ptoPolicy.name' },
];

const BALANCE_STATUS_OPTIONS: EnumOption[] = [
  { value: 'ACTIVE', label: 'Active' },
  { value: 'TERMINATED', label: 'Terminated' },
];

const TIMEOFF_FILTER_FIELDS: FilterFieldDef[] = [
  { key: 'status', label: 'Status', type: 'enum', icon: 'fa-circle', backendField: 'status' },
  { key: 'reason', label: 'Reason', type: 'text', icon: 'fa-comment', backendField: 'reason' },
  { key: 'dates', label: 'Actual Dates', type: 'daterange', icon: 'fa-calendar', backendField: 'startDate' },
];

const TIMEOFF_STATUS_OPTIONS: EnumOption[] = [
  { value: 'PENDDING', label: 'Requested' },
  { value: 'APPROVE', label: 'Approved' },
  { value: 'REPPROVE', label: 'Denied' },
  { value: 'CANCELED', label: 'Canceled' },
];

const buildPtoBackendFilters = (active: ActiveFilter[], fields: FilterFieldDef[]): any[] => {
  const out: any[] = [];
  active.forEach((f) => {
    const def = fields.find((d) => d.key === f.key);
    if (!def?.backendField) return;
    const field = def.backendField;

    if (def.type === 'enum') {
      const vals = f.value as string[];
      if (vals?.length) out.push({ field, operation: 'in', value: vals });
    } else if (def.type === 'text') {
      const v = ((f.value as string) || '').trim();
      if (v) out.push({ field, operation: 'ilike', value: v });
    } else if (def.type === 'daterange') {
      const v = f.value as { from: string; to: string };
      if (v?.from) out.push({ field, operation: '>=', value: `${v.from} 00:00:00` });
      if (v?.to) out.push({ field, operation: '<=', value: `${v.to} 23:59:59` });
    }
  });
  return out;
};

const Pto = (props: { showModal?: boolean }) => {
  const { isMobile } = useCheckMobileScreen();
  const { token, currentSchool, user }: any = useContext(AuthContext);
  const { showModal } = props;
  const isAdminUser =
    isAdmin(user) ||
    isDirector(user) ||
    isEducationDirectorAdminAssistant(user) ||
    isUpperManagement(user) ||
    isHRUser(user) ||
    isFinanceUser(user);
  const [activeTab, setActiveTab] = useState('1');
  const [balanceActiveFilters, setBalanceActiveFilters] = useState<ActiveFilter[]>([]);
  const [balanceSearch, setBalanceSearch] = useState('');
  const debouncedBalanceSearch = useDebounce(balanceSearch, 400);
  const runBalanceList = useLatestRequest();
  const didMountBalanceFilters = useRef(false);
  const [requestActiveFilters, setRequestActiveFilters] = useState<ActiveFilter[]>([]);
  const [requestSearch, setRequestSearch] = useState('');
  const [policyOptions, setPolicyOptions] = useState<EnumOption[]>([]);
  const [isOpenTimeOff, setIsOpenTimeOff] = useState(false);
  const [requestDetailsData, setRequestDetailsData] = useState<any>();
  const [isRequestDetailsOpen, setIsRequestDetailsOpen] = useState(false);
  const childRef = useRef<{ reloadData: any }>(null);

  const [modalBalanceOpen, setModalBalanceOpen] = useState(false);
  const [modalHollidayOpen, setModalHollidayOpen] = useState(false);
  const [balanceDetailData, setBalanceDetailData] = useState<any>();
  const [userBalanceDetailFormEditMode, setUserBalanceDetailFormEditMode] = useState(false);

  const [editPtoRequestData, setEditPtoRequestData] = useState(null) as any;
  const setFormDataIfIsOpened = (data?: any) => {
    if (!data || data?.constructor?.name === 'SyntheticBaseEvent') return false;
    setEditPtoRequestData({
      ptoId: data.id,
      selectedEmployeeId: data.user?.id,
      reason: data.reason,
      startDate: data.startDate,
      endDate: data.endDate || data.startDate,
      hours: data.hours,
      describe: data.describe,
      timeRequested:
        data.startDate === data.endDate || data.endDate === undefined ? 'Less than one day' : 'One or more Days',
    });
  };

  const toggleTimeOff = (data?: any) => {
    setFormDataIfIsOpened(data);
    setIsOpenTimeOff(!isOpenTimeOff);
    loadList(filteredOptions);
    loadRequests(
      moment(data?.startDate).startOf('month').startOf('week'),
      moment(data?.startDate).endOf('month').endOf('week'),
    );
    loadRequestsMonthScheduled();
    loadRequestData();
    setIsRequestDetailsOpen(false);
  };

  const customStyles = {
    navLink: {
      minHeight: '42px',
      paddingTop: '8px',
      cursor: 'pointer',
      border: '0',
    },
    navLinkClickedALter: {
      minHeight: '42px',
      paddingTop: '8px',
      cursor: 'pointer',
      border: '0',
      borderBottom: '2px solid #FF7B00',
    },
  };

  const confirmRepprove = (e: any, id: string) => {
    if (data?.constructor?.name === 'SyntheticBaseEvent') e.preventDefault();

    return confirmAlertWithForm({
      title: 'Deny',
      messageType: 'DELETE',
      message: 'Are you sure to deny this pto request?',
      children: (
        <Row>
          <Col>
            <FormGroup className="form-control-label">
              <Label>Reason</Label>
              <Input type="textarea" name="reason" required />
            </FormGroup>
          </Col>
        </Row>
      ),
      onSubmit: async (e: any) => {
        e.preventDefault();
        setLoading(true);
        try {
          const formData = new FormData(e.target as HTMLFormElement);
          const body = {} as any;
          for (const [key, value] of formData.entries()) {
            (body as any)[key] = value;
          }
          await handleRepprove(id, body);
        } catch (e: any) {
          toast.error(e?.response?.data?.message || 'Failed to cancel pto request');
          console.error(e?.response?.data?.message || 'Failed to cancel pto request');
        } finally {
          setLoading(false);
        }
      },
    });
  };

  const confirmApprove = (e: any, id: string) => {
    if (data?.constructor?.name === 'SyntheticBaseEvent') e.preventDefault();

    confirmAlert({
      customUI: ({ onClose }) => {
        return <PtoReproveConfirm id={id} handleRepprove={handleApprove} type="approve" onClose={onClose} />;
      },
    });
  };

  const columnsBalance = BalanceCollumns({
    setBalanceDetailData,
    setUserBalanceDetailFormEditMode,
    setModalBalanceOpen,
    isMobile,
  });

  const columnsRequests = RequestCollumns({
    setRequestDetailsData,
    setIsRequestDetailsOpen,
    user,
    confirmApprove,
    confirmRepprove,
    isMobile,
  });

  const columnsScheduled = ScheduledCollumns({
    setRequestDetailsData,
    setIsRequestDetailsOpen,
    isAdminUser,
    confirmRepprove,
    isMobile,
  });

  const [data, setData] = useState([] as any[]);
  const [currentStartDate, setCurrentStartDate] = useState<any>();
  const [currentEndDate, setCurrentEndDate] = useState<any>();
  const [scheduledData, setScheduledData] = useState([] as any[]);
  const [scheduledMonthData, setScheduledMonthData] = useState([] as any[]);
  const [events, setEvents] = useState([] as any[]);

  const [loading, setLoading] = useState(false);

  const [weekendsVisible, setWeekendsVisible] = useState(false);
  const [pagedMeta, setPagedMeta] = useState(createPagedMeta());
  const [filteredOptions, setFilteredOptions] = useState<{ filters: any[]; options: any }>({
    filters: [],
    options: createOptionsPage(pagedMeta),
  });
  const [requestFilteredOptions, SetRequestFilteredOptions] = useState<{ filters: any[]; options: any }>({
    filters: [],
    options: createOptionsPage(pagedMeta),
  });
  const [toggleModal, setToggleModal] = useState(false);
  const handleToggleModal = () => setToggleModal(!toggleModal);

  const [blackoutDatesModal, setBlackoutDatesModal] = useState(false);
  const handleToggleBlackoutDatesModal = () => {
    if (blackoutDatesModal === true) {
      setClickedBlackoutData({});
      setClickedBlackoutId('');
      setBlackoutDatesModalViewMode(false);
    }
    setBlackoutDatesModal(!blackoutDatesModal);
  };
  const [blackoutDates, setBlackoutDates] = useState([] as any[]);
  const [hollidayDates, setHollidayDates] = useState([] as any[]);
  const [clickedEvent, setClickedEvent] = useState({} as { data?: {}; event?: { groupId: string } });
  const [clickedBlackoutId, setClickedBlackoutId] = useState('');
  const [clickedHollidayId, setClickedHollidayId] = useState('');
  const [clickedHollidayData, setClickedHollidayData] = useState<any>();
  const [clickedBlackoutData, setClickedBlackoutData] = useState<any>();
  const [blackoutDatesModalViewMode, setBlackoutDatesModalViewMode] = useState(false);
  const [blackoutEvents, setBlackoutEvents] = useState([]);
  const [hollidayEvents, setHollidayEvents] = useState([]);
  const canEditRequest =
    isAdmin(user) ||
    isDirector(user) ||
    isUpperManagement(user) ||
    isEducationDirectorAdminAssistant(user) ||
    isHRUser(user) ||
    isFinanceUser(user);
  const [eventsInfo, setEventsInfo] = useState({});

  const [toggleModalPending, setToggleModalPending] = useState(!!showModal);
  const eventCollor = {
    requests: {
      reasonDayOffNonPaid: '#FFBF00',
      paiedAndFourHoursOrLess: '#6399E5',
      paiedAndMoreThanFourHour: '#14b11c',
      default: '#bbbbbb',
    },
    hollidays: '#e4605e',
    blackouts: '#172b4d',
  } as const;

  const calendarLegend = [
    { color: eventCollor.requests.default, label: 'Pending Requests' },
    { color: eventCollor.requests.paiedAndFourHoursOrLess, label: 'Requests with < 4 hrs' },
    { color: eventCollor.requests.paiedAndMoreThanFourHour, label: 'Requests with > 4 hrs' },
    { color: eventCollor.requests.reasonDayOffNonPaid, label: 'Requests with non paid day' },
    { color: eventCollor.hollidays, label: 'Holidays' },
    { color: eventCollor.blackouts, label: 'Blackout Dates' },
  ];

  const changeWeekendsVisible = () => {
    setWeekendsVisible(!weekendsVisible);
  };
  const renderEventContent = (eventContent: EventContentArg) => {
    return (
      <>
        <b>{eventContent.timeText}</b>
        <i data-tip={eventContent.event.extendedProps.observations}>{eventContent.event.title}</i>
        <ReactTooltip />
      </>
    );
  };

  const handleSort = async (column: string, direction: string) => {
    const options = { ...filteredOptions.options, sortBy: [column], sortDesc: [direction !== 'asc'] };
    const newFilteredOptions = {
      filters: filteredOptions.filters,
      options,
    };
    newFilteredOptions.options.page = 1;
    setFilteredOptions(newFilteredOptions);
  };

  useEffect(() => {
    loadList(filteredOptions);
  }, [filteredOptions, currentSchool]);

  useEffect(() => {
    if (currentStartDate && currentEndDate) {
      loadRequests(moment(currentStartDate), moment(currentEndDate));
    } else {
      loadRequests();
    }
    loadRequestsMonthScheduled();
  }, [currentSchool]);

  useEffect(() => {
    loadRequestData();
  }, [requestFilteredOptions]);

  useEffect(() => {
    const loadPolicyOptions = async () => {
      try {
        const result = await PtoService(token).ptoPolicyList();
        const names: string[] = (result?.data || []).map((p: any) => p?.name).filter(Boolean);
        const unique = Array.from(new Set(names));
        setPolicyOptions(unique.map((name) => ({ value: name, label: name })));
      } catch (e) {
        setPolicyOptions([]);
      }
    };
    loadPolicyOptions();
  }, [token]);

  const loadList = async (filteredOptions: FilteredOptionsInterface) =>
    runBalanceList(async ({ signal, isCurrent }) => {
      try {
        setLoading(true);
        const newFilteredOptions = JSON.parse(JSON.stringify(filteredOptions));
        if (!newFilteredOptions?.options) {
          newFilteredOptions.options = createOptionsPage(pagedMeta);
        }
        const filter = {
          field: 'schoolId',
          operation: 'hash',
          value: currentSchool.value,
        };
        if (!Array.isArray(newFilteredOptions?.filters)) {
          newFilteredOptions.filters = [];
        }
        newFilteredOptions.filters.push(filter);
        if (!isAdminUser) {
          newFilteredOptions.filters.push({
            field: 'userId',
            operation: 'hash',
            value: user.id,
          });
        }
        if (!newFilteredOptions.filters.some((f: any) => f.field === 'status')) {
          newFilteredOptions.filters.push({
            field: 'status',
            operation: 'in',
            value: ['ACTIVE', 'TERMINATED'],
          });
        }
        const result = await EmployeeService(token || '').list(newFilteredOptions, signal);
        if (!isCurrent()) return;
        const dataResult = result?.data || [];
        let data = dataResult;

        if (isDirector(user))
          data = dataResult?.filter((d: any) => d?.supervisorId === user?.id || d?.userId === user?.id);

        if (isEducationDirectorAdminAssistant(user)) {
          data = dataResult?.filter((d: any) => d?.supervisorId === user?.employee?.supervisorId);
        }

        setData(data);
        const meta: PagedMetaInterface = result.meta;
        if (meta) {
          setPagedMeta(meta);
        }
      } catch (e: any) {
        if (isRequestCanceled(e) || !isCurrent()) return;
        const message = String(e?.response?.data?.message || 'Error fetching list');
        toast.error(message);
      } finally {
        if (isCurrent()) setLoading(false);
      }
    });

  const canSeeRequestDetails = (value: any) => {
    if (isAdmin(user) || isUpperManagement(user) || isHRUser(user) || isFinanceUser(user)) return true;
    if (isAdminUser && value.userId != user.id && value.status !== 'APPROVE') {
      return (
        (isDirector(user) && user.id == value.user.employee.supervisorId) ||
        (isEducationDirectorAdminAssistant(user) && user.employee.supervisorId == value.user.employee.supervisorId)
      );
    }
    return value.userId == user.id || value.status === 'APPROVE';
  };

  const getColorOfEvent = (event: any) => {
    if (event.status !== 'PENDDING') {
      if (event.reason === 'Day Off Non Paid') {
        return eventCollor.requests.reasonDayOffNonPaid;
      }
      if (event.hours <= 4) {
        return eventCollor.requests.paiedAndFourHoursOrLess;
      }
      return eventCollor.requests.paiedAndMoreThanFourHour;
    }
    return eventCollor.requests.default;
  };

  const getTitleOfEvent = (event: any) => {
    if (!canSeeRequestDetails(event)) {
      return 'Pending Request';
    }
    return `${event?.user?.firstName} ${event?.user?.lastName}`;
  };

  const loadRequests = async (
    start: Moment = moment().startOf('month').startOf('week'),
    end: Moment = moment().endOf('month').endOf('week'),
  ) => {
    const result = await PtoService(token).timeOffRequestListByDates(currentSchool.value, start, end);

    const scheduledList = result?.data?.filter((value: any) => value.status === 'APPROVE');
    const eventsListData = result?.data?.filter((value: any) => !['REPPROVE', 'CANCELED'].includes(value.status));

    const eventsList = [];
    if (eventsListData?.length) {
      for (const b of eventsListData) {
        if (!b?.startDate || !b?.endDate) continue;
        if (moment(b?.endDate).utc() > moment(b?.startDate).utc()) {
          let currentDate = moment(b?.startDate).utc();
          while (moment(b?.endDate).utc() >= currentDate) {
            eventsList.push({
              id: b.id,
              title: getTitleOfEvent(b),
              start: currentDate.format('YYYY-MM-DD'),
              end: currentDate.format('YYYY-MM-DD'),
              color: getColorOfEvent(b),
              groupId: 'event',
            });
            currentDate = currentDate.add(1, 'day');
          }
        }
        if (moment(b?.endDate).utc().format('YYYY-MM-DD') === moment(b?.startDate).utc().format('YYYY-MM-DD')) {
          eventsList.push({
            id: b.id,
            title: getTitleOfEvent(b),
            start: moment(b?.startDate).utc().format('YYYY-MM-DD'),
            end: moment(b?.endDate).utc().format('YYYY-MM-DD'),
            color: getColorOfEvent(b),
            groupId: 'event',
          });
        }
      }
    }

    const blackouts = await BlackoutDate(token).list(currentSchool.value);
    const blackoutsData = blackouts?.data || [];
    setBlackoutEvents(blackoutsData);
    const blackoutDatesArray = [];
    if (blackoutsData?.length) {
      for (const b of blackoutsData) {
        if (!b?.startDate || !b?.endDate) continue;
        if (moment(b?.endDate).utc() > moment(b?.startDate).utc()) {
          let currentDate = moment(b?.startDate).utc();
          while (moment(b?.endDate).utc() >= currentDate) {
            blackoutDatesArray.push(currentDate.format('YYYY-MM-DD'));
            eventsList.push({
              id: b.id,
              title: b?.reason || '',
              start: currentDate.format('YYYY-MM-DD'),
              end: currentDate.format('YYYY-MM-DD'),
              color: eventCollor.blackouts,
              groupId: 'blackout',
              // display: 'background',
            });
            currentDate = currentDate.add(1, 'day');
          }
        }
        if (moment(b?.endDate).utc().format('YYYY-MM-DD') === moment(b?.startDate).utc().format('YYYY-MM-DD')) {
          blackoutDatesArray.push(moment(b?.startDate).utc().format('YYYY-MM-DD'));
          eventsList.push({
            id: b.id,
            title: b?.reason || '',
            start: moment(b?.startDate).utc().format('YYYY-MM-DD'),
            end: moment(b?.endDate).utc().format('YYYY-MM-DD'),
            color: eventCollor.blackouts,
            groupId: 'blackout',
            // display: 'background',
          });
        }
      }
      setBlackoutDates(blackoutDatesArray);
    }

    const hollidays = await Holidays(token).list(parseInt(moment().format('YYYY')), currentSchool.value);
    const hollidaysData = hollidays?.data || [];
    setHollidayEvents(hollidaysData);
    const hollidayDatesArray = [];
    if (hollidaysData?.length) {
      for (const h of hollidaysData) {
        if (!h?.startDate || !h?.endDate) continue;
        if (moment(h?.endDate).utc() > moment(h?.startDate).utc()) {
          let currentDate = moment(h?.startDate).utc();
          while (moment(h?.endDate).utc() >= currentDate) {
            hollidayDatesArray.push(currentDate.format('YYYY-MM-DD'));
            eventsList.push({
              id: h.id,
              title: h?.name || '',
              start: currentDate.format('YYYY-MM-DD'),
              end: currentDate.format('YYYY-MM-DD'),
              color: eventCollor.hollidays,
              groupId: 'holliday',
              // display: 'background',
            });
            currentDate = currentDate.add(1, 'day');
          }
        }
        if (moment(h?.endDate).utc().format('YYYY-MM-DD') === moment(h?.startDate).utc().format('YYYY-MM-DD')) {
          hollidayDatesArray.push(moment(h?.startDate).utc().format('YYYY-MM-DD'));
          eventsList.push({
            id: h.id,
            title: h?.name || '',
            start: moment(h?.startDate).utc().format('YYYY-MM-DD'),
            end: moment(h?.endDate).utc().format('YYYY-MM-DD'),
            color: eventCollor.hollidays,
            groupId: 'holliday',
            // display: 'background',
          });
        }
      }
      setHollidayDates(hollidayDatesArray);
    }

    setEventsInfo({
      event: result.data,
      blackout: blackouts.data,
      holliday: hollidays.data,
    });

    let data = scheduledList;
    if (isDirector(user))
      data = scheduledList?.filter(
        (d: any) => d?.user?.employee?.supervisorId === user?.id || d?.user?.id === user?.id,
      );

    setScheduledData(data);
    // setPenddingData(penddingList);
    setEvents(eventsList);
  };

  const [requestDataTableProp, setRequestDataTableProps] = useState({ data: [], meta: { total: 0 } });
  const loadRequestData = async () => {
    setLoading(true);
    try {
      const currFilteredOption = JSON.parse(JSON.stringify(requestFilteredOptions));
      const userFilters = Array.isArray(currFilteredOption.filters) ? currFilteredOption.filters : [];
      const hasStatusFilter = userFilters.some((f: any) => f.field === 'status');
      currFilteredOption.filters = [
        ...userFilters,
        ...(hasStatusFilter
          ? []
          : [{ field: 'status', operation: 'in', value: ['APPROVE', 'PENDDING', 'REPPROVE', 'CANCELED'] }]),
      ];
      currFilteredOption.options.sortBy = ['startDate'];
      currFilteredOption.options.sortDesc = [false];
      const result: any = await PtoService(token).timeOffRequestList(currentSchool.value, currFilteredOption);
      const dataResult = result?.data || [];
      const data = isDirector(user)
        ? dataResult?.filter((d: any) => d?.user?.employee?.supervisorId === user?.id || d?.user?.id === user?.id)
        : dataResult;

      result.data = data;
      setRequestDataTableProps(result);
    } catch (e: any) {
      toast.error(e?.response?.data?.message || 'No data Found!');
    } finally {
      setLoading(false);
    }
  };

  const loadRequestsMonthScheduled = async () => {
    const result: any = await PtoService(token).timeOffRequestListApprovedThisMonth(currentSchool.value);

    setScheduledMonthData(result.data);
  };

  const handleApprove = async (id: string) => {
    try {
      await PtoService(token).timeOffRequestApprove(id);
      loadList(filteredOptions);
      if (currentStartDate && currentEndDate) {
        loadRequests(moment(currentStartDate), moment(currentEndDate));
      } else {
        loadRequests();
      }
      loadRequestsMonthScheduled();
      loadRequestData();
      childRef.current?.reloadData();
      toast.success('Approve Successfully!');
    } catch (err: any) {
      toast.error(err?.response?.data?.message || 'Approve error!');
      console.log(err);
    }
  };

  const handleRepprove = async (id: string, body: any) => {
    try {
      await PtoService(token).timeOffRequestRepprove(id, body);
      loadList(filteredOptions);
      if (currentStartDate && currentEndDate) {
        loadRequests(moment(currentStartDate), moment(currentEndDate));
      } else {
        loadRequests();
      }
      loadRequestsMonthScheduled();
      loadRequestData();
      childRef.current?.reloadData();
      toast.success('Repprove Successfully!');
    } catch (err: any) {
      toast.error(err?.response?.data?.message || 'Reprove error!');
      console.log(err);
    }
  };

  const handlePerRowsChange = async (perPage: number) => {
    const newOptions = {
      ...pagedMeta,
      perPage,
    };
    const newFilteredOptions = {
      filters: filteredOptions.filters,
      options: createOptionsPage(newOptions),
    };
    setFilteredOptions(newFilteredOptions);
  };

  const handlePageChange = async (page: number) => {
    const newOptions = {
      ...pagedMeta,
      currentPage: page,
    };
    const newFilteredOptions = {
      filters: filteredOptions.filters,
      options: createOptionsPage(newOptions),
    };
    setFilteredOptions(newFilteredOptions);
  };

  const handlePageChangeRequest = async (page: number) => {
    const newOptions = {
      ...pagedMeta,
      currentPage: page,
    };
    const newFilteredOptions = {
      filters: requestFilteredOptions.filters,
      options: createOptionsPage(newOptions),
    };
    SetRequestFilteredOptions(newFilteredOptions);
  };

  const handlePerRowsChangeRequest = async (perPage: number) => {
    const newOptions = {
      ...pagedMeta,
      perPage,
    };
    const newFilteredOptions = {
      filters: requestFilteredOptions.filters,
      options: createOptionsPage(newOptions),
    };
    SetRequestFilteredOptions(newFilteredOptions);
  };

  const handleDateClick = (selectInfo: any) => {
    const date = new Date(selectInfo.date).toISOString().replace(/T.*$/, '');
    if (events.find((item) => item.start === date && item.groupId === 'blackout') && !isAdminUser) {
      return false;
    }
    toggleTimeOff({ startDate: date });
  };

  useEffect(() => {
    if (!Object.values(clickedEvent).length) {
      return;
    }

    switch (clickedEvent.event?.groupId) {
      case 'event':
        if (!canSeeRequestDetails(clickedEvent.data)) return;
        if (!canEditRequest && (clickedEvent?.data as any)?.userId !== user.id) return;

        if (
          (clickedEvent?.data as any)?.userId !== user.id &&
          ((isDirector(user) && (clickedEvent?.data as any)?.user?.employee?.supervisorId !== user.id) ||
            (isEducationDirectorAdminAssistant(user) &&
              (clickedEvent?.data as any)?.user?.employee?.supervisorId !== user.employee.supervisorId))
        )
          return;

        setRequestDetailsData(clickedEvent.data);
        setIsRequestDetailsOpen(true);
        break;
      case 'blackout':
        if (!canEditRequest) return;
        setClickedBlackoutData(clickedEvent.data);
        setBlackoutDatesModalViewMode(true);
        handleToggleBlackoutDatesModal();
        break;
      case 'holliday':
        if (!canEditRequest) return;
        setClickedHollidayData(clickedEvent.data);
        setModalHollidayOpen(true);
        break;
    }
  }, [clickedEvent]);

  useEffect(() => {
    if (clickedBlackoutId === '') {
      return;
    }
    setClickedBlackoutData(blackoutEvents.find((item: any) => item.id === clickedBlackoutId));
    setBlackoutDatesModalViewMode(true);
    handleToggleBlackoutDatesModal();
  }, [clickedBlackoutId]);

  useEffect(() => {
    if (clickedHollidayId === '') {
      return;
    }
    setClickedHollidayData(hollidayEvents.find((item: any) => item.id === clickedHollidayId));
    setModalHollidayOpen(true);
  }, [clickedHollidayId]);

  const alterDatesSetCalendar = async (args: DatesSetArg) => {
    const start = moment(args.start).utc();
    const end = moment(args.end).utc();
    setCurrentStartDate(start);
    setCurrentEndDate(end);
    await loadRequests(start, end);
  };

  const buildBalanceFilters = (active: ActiveFilter[], searchText: string): any[] => {
    const out = buildPtoBackendFilters(active, BALANCE_FILTER_FIELDS);
    const search = (searchText || '').trim();
    if (search) out.push({ field: 'user.firstName', operation: 'ilike', value: search });
    return out;
  };

  useEffect(() => {
    if (!didMountBalanceFilters.current) {
      didMountBalanceFilters.current = true;
      return;
    }
    setFilteredOptions((prev: any) => ({
      filters: buildBalanceFilters(balanceActiveFilters, debouncedBalanceSearch),
      options: { ...prev.options, page: 1 },
    }));
  }, [debouncedBalanceSearch, balanceActiveFilters]);

  const handleSearch = (text: string) => {
    setBalanceSearch(text || '');
  };

  const handleBalanceFiltersChange = (next: ActiveFilter[]) => {
    setBalanceActiveFilters(next);
  };

  const balanceOptionsFor = (key: string): EnumOption[] => {
    if (key === 'status') return BALANCE_STATUS_OPTIONS;
    if (key === 'policy') return policyOptions;
    return [];
  };

  const buildRequestFilters = (active: ActiveFilter[], searchText: string): any[] => {
    const out = buildPtoBackendFilters(active, TIMEOFF_FILTER_FIELDS);
    const search = (searchText || '').trim();
    if (search) out.push({ field: 'user.firstName', operation: 'ilike', value: search });
    return out;
  };

  const applyRequestFilters = (active: ActiveFilter[], searchText: string) => {
    SetRequestFilteredOptions((prev: any) => ({
      filters: buildRequestFilters(active, searchText),
      options: { ...prev.options, page: 1 },
    }));
  };

  const handleRequestSearch = (text: string) => {
    setRequestSearch(text || '');
    applyRequestFilters(requestActiveFilters, text || '');
  };

  const handleRequestFiltersChange = (next: ActiveFilter[]) => {
    setRequestActiveFilters(next);
    applyRequestFilters(next, requestSearch);
  };

  const requestOptionsFor = (key: string): EnumOption[] => {
    if (key === 'status') return TIMEOFF_STATUS_OPTIONS;
    return [];
  };

  return (
    <>
      <CommonHeader />
      <PtoRequestDetail
        data={requestDetailsData}
        canEdit={
          isAdmin(user) ||
          ((isDirector(user) || isUpperManagement(user) || isHRUser(user)) &&
            requestDetailsData &&
            user.id !== requestDetailsData.userId)
        }
        isOpen={isRequestDetailsOpen}
        toggle={() => {
          setClickedEvent({});
          setIsRequestDetailsOpen(!isRequestDetailsOpen);
          return false;
        }}
        clickOnEdit={(data) => toggleTimeOff(data)}
        clickOnApprove={(data) => {
          setClickedEvent({});
          setIsRequestDetailsOpen(!isRequestDetailsOpen);
          confirmApprove({}, data.id);
        }}
        clickOnReprove={(data) => {
          setClickedEvent({});
          setIsRequestDetailsOpen(!isRequestDetailsOpen);
          confirmRepprove({}, data.id);
        }}
        clickOnCancel={(data) => {
          return confirmAlertWithForm({
            title: 'Cancel',
            messageType: 'DELETE',
            message: 'Are you sure to cancel this pto request?',
            children: (
              <Row>
                <Col>
                  <FormGroup className="form-control-label">
                    <Label>Reason</Label>
                    <Input type="textarea" name="reason" required />
                  </FormGroup>
                </Col>
              </Row>
            ),
            onSubmit: async (e: any) => {
              e.preventDefault();
              setLoading(true);
              try {
                const formData = new FormData(e.target as HTMLFormElement);
                const body = {} as any;
                for (const [key, value] of formData.entries()) {
                  (body as any)[key] = value;
                }
                await PtoService(token).timeOffRequestCancel(data?.id, body);
                setClickedEvent({});
                setIsRequestDetailsOpen(!isRequestDetailsOpen);
                loadList(filteredOptions);
                if (currentStartDate && currentEndDate) {
                  loadRequests(moment(currentStartDate), moment(currentEndDate));
                } else {
                  loadRequests();
                }
                loadRequestsMonthScheduled();
                loadRequestData();
                toast.success('Cancel Successfully!');
              } catch (e: any) {
                toast.error(e?.response?.data?.message || 'Failed to cancel pto request');
                console.error(e?.response?.data?.message || 'Failed to cancel pto request');
              } finally {
                setLoading(false);
              }
            },
          });
        }}
      />
      <Modal
        className="modal-dialog-centered"
        isOpen={modalBalanceOpen}
        toggle={() => setModalBalanceOpen(!modalBalanceOpen)}
        size={'xl'}
      >
        {balanceDetailData && (
          <>
            <div className="modal-header">
              <div className="d-flex align-items-center">
                <div style={{ width: '35px', height: '35px', borderRadius: '50%', overflow: 'hidden', flexShrink: 0 }}>
                  <img
                    src={balanceDetailData.user.picture}
                    alt="User Profile"
                    className="img-fluid"
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                  />
                </div>
                <a
                  href={`/users/${balanceDetailData.userId}/profile`}
                  className="ml-2 text-primary font-weight-bold text-sm"
                >
                  <span className="ml-2 text-primary font-weight-bold text-sm">{`${
                    balanceDetailData.user.firstName || '-'
                  } ${balanceDetailData.user.lastName || '-'}`}</span>
                </a>
              </div>
              <div className="d-flex p-1">
                <a
                  onClick={() => setModalBalanceOpen(!modalBalanceOpen)}
                  className="cursor-pointer"
                  style={{ color: '#525f7f' }}
                >
                  <i className="fas fa-times" />
                </a>
              </div>
            </div>
            <div className="modal-body mt-0 pt-0">
              <UserBalanceDetailForm
                data={balanceDetailData}
                editMode={userBalanceDetailFormEditMode}
                onSave={() => {
                  setUserBalanceDetailFormEditMode(false);
                  setModalBalanceOpen(!modalBalanceOpen);
                  loadList(filteredOptions);
                }}
              />
            </div>
          </>
        )}
      </Modal>
      <Modal
        className="modal-dialog-centered"
        isOpen={modalHollidayOpen}
        toggle={() => {
          setClickedHollidayData({});
          setClickedHollidayId('');
          setModalHollidayOpen(!modalHollidayOpen);
        }}
        size={'md'}
      >
        {clickedHollidayData && (
          <>
            <div className="modal-header">
              <h4 className="modal-title">Holiday: {clickedHollidayData.name}</h4>
              <div
                onClick={() => {
                  setClickedHollidayData({});
                  setClickedHollidayId('');
                  setModalHollidayOpen(!modalHollidayOpen);
                }}
                className="d-flex p-1 cursor-pointer"
              >
                <i className="fas fa-times" />
              </div>
            </div>
            <div className="modal-body mt-0 pt-0">
              <PtoHollidayDetail data={clickedHollidayData} />
            </div>
          </>
        )}
      </Modal>
      <ModalTimeoffRequest
        isOpen={isOpenTimeOff}
        toggleModal={toggleTimeOff}
        currentUser={user}
        blackoutDates={blackoutDates}
        hollidayDates={hollidayDates}
        editPtoRequestData={editPtoRequestData}
      />
      <Container className="mt--8" fluid>
        <Row>
          <Col xs="0" md="3"></Col>
          {canEditRequest && (
            <Col xs="6" md="3">
              {/* <button onClick={reloadPendingRequestsData}>dsa</button> */}
              <PenddingRequestInfo
                setRequestDetailsData={setRequestDetailsData}
                setIsRequestDetailsOpen={setIsRequestDetailsOpen}
                confirmApprove={confirmApprove}
                confirmRepprove={confirmRepprove}
                toggleModalPending={toggleModalPending}
                setToggleModalPending={setToggleModalPending}
                ref={childRef}
              />
            </Col>
          )}
          {canEditRequest && (
            <Col xs="6" md="3">
              {isMobile ? (
                <CardWidget
                  title="Scheduled/this month"
                  text={String(isDirector(user) ? scheduledData?.length : scheduledMonthData?.length)}
                  icon="fa-check"
                  iconColor="primary"
                  tag="h6"
                  cursor="pointer"
                  onClick={handleToggleModal}
                />
              ) : (
                <CardInfo
                  count={isDirector(user) ? scheduledData?.length : scheduledMonthData?.length}
                  class="bg-success card-info-mg-button"
                  title="Scheduled off this month"
                  icon="fa-check"
                  toggle={handleToggleModal}
                />
              )}

              <ModalContent
                title="Scheduled off this month"
                class="pt-0"
                modal={toggleModal}
                toggle={handleToggleModal}
                size="xl"
              >
                <Row>
                  <Col xs="12">
                    <DataTable
                      columns={columnsScheduled}
                      data={isDirector(user) || isUpperManagement(user) ? scheduledData : scheduledMonthData}
                      header={false}
                      totalRows={pagedMeta?.total}
                      loading={loading}
                      onChangeRowsPerPage={handlePerRowsChange}
                      onChangePage={handlePageChange}
                    />
                  </Col>
                </Row>
              </ModalContent>
            </Col>
          )}
          <Col xs="0" md="3"></Col>
          <Col className="text-right mt-3" xl="12">
            {(isAdmin(user) || isUpperManagement(user) || isHRUser(user)) && !isMobile && (
              <Button
                className="bg-default text-white mb-2"
                onClick={handleToggleBlackoutDatesModal}
                size={isMobile ? 'sm' : 'md'}
              >
                Add Blackout Dates
              </Button>
            )}
          </Col>
          <Col xl="12" className="bg-secondary shadow pt-3">
            <div className="calendar-app">
              <div className="calendar-app-sidebar">
                <div className="calendar-app-sidebar-section pb-2">
                  {canEditRequest && (
                    <label>
                      <input type="checkbox" checked={weekendsVisible} onChange={() => changeWeekendsVisible()}></input>
                      &nbsp;Show weekends?
                    </label>
                  )}
                  {(isAdmin(user) || isUpperManagement(user)) && isMobile && (
                    <Button
                      className="bg-default text-white float-right"
                      onClick={handleToggleBlackoutDatesModal}
                      size={isMobile ? 'sm' : 'md'}
                    >
                      Add Blackout Dates
                    </Button>
                  )}
                </div>
              </div>
              {/* <div className="calendar-app-main">
                          <PtoRequestsCallendar
                            isAdminUser
                            weekendsVisible={weekendsVisible}
                            reload={ptoCallendarReload}
                            eventClick={(e: any) => {
                              setClickedEvent(e);
                            }}
                            dateClick={handleDateClick}
                          />
                        </div> */}
              <div className="calendar-app-main">
                <FullCalendar
                  plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin, listPlugin]}
                  headerToolbar={{
                    left: 'prev,next',
                    center: 'title',
                    right: 'today',
                  }}
                  eventTimeFormat={{
                    hour: 'numeric',
                    minute: '2-digit',
                    meridiem: 'short',
                  }}
                  initialView="dayGridMonth"
                  editable={false}
                  selectable={false}
                  selectMirror={true}
                  dayMaxEvents={false}
                  weekends={weekendsVisible}
                  events={events}
                  eventContent={renderEventContent}
                  eventClick={(e) => {
                    setClickedEvent({
                      ...e,
                      ...{
                        data: (eventsInfo as any)[e.event.groupId as any].find((item: any) => item.id === e.event.id),
                      },
                    });
                  }}
                  dateClick={handleDateClick}
                  datesSet={alterDatesSetCalendar}
                />
              </div>
            </div>
            {isAdminUser &&
              (isMobile ? (
                <div className="d-flex flex-wrap mt-1 mb-2" style={{ gap: '0.35rem 0.9rem' }}>
                  {calendarLegend.map((legend) => (
                    <span
                      key={legend.label}
                      className="d-inline-flex align-items-center text-muted"
                      style={{ fontSize: '0.72rem', lineHeight: 1.4 }}
                    >
                      <i className="fas fa-circle mr-1" style={{ color: legend.color, fontSize: '0.55rem' }} />
                      {legend.label}
                    </span>
                  ))}
                </div>
              ) : (
                <ul className="list-group list-group-horizontal mt-1 mb-1">
                  {calendarLegend.map((legend) => (
                    <li className="list-group-item flex-fill" key={legend.label}>
                      <i className="fas fa-circle mr-2" style={{ color: legend.color }} />
                      {legend.label}
                    </li>
                  ))}
                </ul>
              ))}
          </Col>

          <Col xs="12" className="text-right mt-3">
            <Button
              style={{ background: '#ff7b00', color: '#FFFFFF' }}
              onClick={toggleTimeOff}
              size={isMobile ? 'sm' : 'md'}
            >
              Add Time Off
            </Button>
          </Col>
          <Col xs="12">
            <Nav tabs>
              <NavItem>
                <NavLink
                  className={`${activeTab === '1' ? 'active' : ''}`}
                  onClick={() => setActiveTab('1')}
                  style={customStyles.navLink}
                >
                  Balances
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={`${activeTab === '2' ? 'active' : ''}`}
                  onClick={() => setActiveTab('2')}
                  style={customStyles.navLink}
                >
                  Time Offs
                </NavLink>
              </NavItem>
              {/* <NavItem>
                <NavLink
                  className={`${activeTab === '3' ? 'active' : ''}`}
                  onClick={() => setActiveTab('3')}
                  style={customStyles.navLink}
                >
                  Scheduled
                </NavLink>
              </NavItem> */}
            </Nav>
          </Col>
          <Col xs="12">
            <TabContent activeTab={activeTab}>
              <TabPane tabId="1">
                <Input
                  type="text"
                  placeholder="Search"
                  className="mb-3 mt-3"
                  value={balanceSearch}
                  onChange={(event: any) => handleSearch(event.target.value)}
                />
                <div className="mb-3">
                  <FilterBar
                    fields={BALANCE_FILTER_FIELDS}
                    filters={balanceActiveFilters}
                    onChange={handleBalanceFiltersChange}
                    optionsFor={balanceOptionsFor}
                  />
                </div>
                <DataTable
                  columns={columnsBalance}
                  data={data}
                  header={false}
                  totalRows={pagedMeta?.total}
                  loading={loading}
                  onChangeRowsPerPage={handlePerRowsChange}
                  onChangePage={handlePageChange}
                  onChangeSort={(column: string, direction: string) => handleSort(column, direction)}
                />
              </TabPane>
            </TabContent>
            <TabContent activeTab={activeTab}>
              <TabPane tabId="2">
                <Input
                  type="text"
                  placeholder="Search"
                  className="mb-3 mt-3"
                  value={requestSearch}
                  onChange={(event: any) => handleRequestSearch(event.target.value)}
                />
                <div className="mb-3">
                  <FilterBar
                    fields={TIMEOFF_FILTER_FIELDS}
                    filters={requestActiveFilters}
                    onChange={handleRequestFiltersChange}
                    optionsFor={requestOptionsFor}
                  />
                </div>
                <DataTable
                  responsive={!isMobile}
                  columns={columnsRequests}
                  data={requestDataTableProp?.data}
                  header={false}
                  totalRows={requestDataTableProp?.meta?.total | 0}
                  loading={loading}
                  onChangeRowsPerPage={handlePerRowsChangeRequest}
                  onChangePage={handlePageChangeRequest}
                />
              </TabPane>
            </TabContent>
            {/* <TabContent activeTab={activeTab}>
              <TabPane tabId="3">
                <DataTable
                  columns={columnsScheduled}
                  data={
                    isAdminUser
                      ? scheduledData
                      : scheduledData?.filter(
                          (d: any) => d?.user?.employee?.supervisorId === user?.id || d?.user?.id === user?.id,
                        )
                  }
                  header={false}
                  totalRows={pagedMeta?.total}
                  loading={loading}
                  onChangeRowsPerPage={handlePerRowsChange}
                  onChangePage={handlePageChange}
                />
              </TabPane>
            </TabContent> */}
          </Col>
        </Row>
      </Container>
      <BlackoutDatesForm
        toogle={handleToggleBlackoutDatesModal}
        change={() => {
          if (currentStartDate && currentEndDate) {
            loadRequests(moment(currentStartDate), moment(currentEndDate));
          } else {
            loadRequests();
          }
        }}
        isOpen={blackoutDatesModal}
        data={clickedBlackoutData}
        viewMode={blackoutDatesModalViewMode}
      />
    </>
  );
};

export default Pto;
